import { readCookie } from './csrf.js';
import type { ResolvedLoggerOptions } from '../types.js';

export async function buildAuthHeaders(
  opts: ResolvedLoggerOptions,
): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};

  const csrf = readCookie(opts.csrfCookieName);
  if (csrf) headers[opts.csrfHeaderName] = csrf;

  if (opts.getAuthToken) {
    try {
      const tokenOrPromise = opts.getAuthToken();
      const token = tokenOrPromise instanceof Promise ? await tokenOrPromise : tokenOrPromise;
      if (token) headers['Authorization'] = `Bearer ${token}`;
    } catch {
      /* swallow; transport will proceed without Bearer */
    }
  }

  return headers;
}
